/**
 * Open API 서비스 이용 신청/해지 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class OpenApiServiceService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * Open API 서비스 신청 현황 조회
     * @returns Open API 서비스 신청 현황 조회 결과
     */
    getStatus() {
        return this.axios.get(`/main/v1/open-api/approval`);
    }
    /**
     * Open API 서비스 이용 신청
     * @returns Open API 서비스 이용 신청 결과
     */
    apply(request) {
        return this.axios.post(`/main/v1/open-api/approval`, request);
    }
    /**
     * Open API 서비스 사용 해지
     * @returns Open API 서비스 사용 해지 결과
     */
    revoke_1(request) {
        return this.axios.delete(`/main/v1/open-api/approval`, { data: request });
    }
    /**
     * Open API 서비스 신청 취소
     * @returns Open API 서비스 신청 취소 결과
     */
    cancelApplication() {
        return this.axios.delete(`/main/v1/open-api/approval/cancel`);
    }
}
//# sourceMappingURL=openapiservice.service.js.map